import React, {PureComponent, ReactNode} from 'react';
import {getLinkPath, scrollToTop, getImageDomain} from 'app/utils';
import {Link} from 'react-router-dom';
import Image from 'app/helpers/Image';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';
import {configStore} from 'app/store/global';
import {observer} from 'mobx-react';

interface Props {
    public_inventory: boolean;
    user_nickname: string;
    profile_image?: string;
    show_profile_image?: boolean;
}

@observer
export default class UserInventoryLink extends PureComponent<Props> {
    render(): ReactNode {
        const {user_nickname, public_inventory, profile_image, show_profile_image} = this.props;
        const {new_year_theme} = configStore.CONFIG;

        return (
            <div className="user-inventory-link">
                {show_profile_image && (
                    profile_image
                        ? <Image
                            image={{
                                name: 'Profile picture',
                                url: getImageDomain(false) + profile_image
                            }}
                            className="profile-image"
                        />
                        : <SpriteIcon name={`#svg-account${new_year_theme ? '-santa' : ''}`} size={{height: 25, width: 25}} />

                )}
                {public_inventory
                    ? <Link
                        to={getLinkPath(`/profile/${user_nickname}`)}
                        onClick={scrollToTop}
                        className="name"
                    >
                        {user_nickname}
                    </Link>
                    : <span className="name">{user_nickname}</span>
                }
            </div>
        );
    }
}
